import {
    FORM_LOCATION_PROP_DOCUMENT_LOCATION,
    FORM_LOCATION_PROP_DOCUMENT_LOCATION_TYPE,
} from '../../../formView/viewForm.formLocation';
import {
    LOCATION_TYPE_DOCUMENT,
    LOCATION_TYPE_LOCAL_FILE,
} from '../../constants/formLocationTypes';
import { parseXmlNative } from '../../utility/xmlHelpers';

// 2023-11-01 - Code moved from loader.js

const parseXml = parseXmlNative;

const getDocumentText = async (
    api,
    shpAccess,
    {
        [FORM_LOCATION_PROP_DOCUMENT_LOCATION_TYPE]: documentLocationType,
        [FORM_LOCATION_PROP_DOCUMENT_LOCATION]: documentLocation,
    },
) => {
    switch (documentLocationType) {
        case LOCATION_TYPE_DOCUMENT:
            // This uses shpPaccess, but if server-side queries are in use, this will work
            // for non-SharePoint URLs as well
            return await shpAccess.queryXmlAsync(documentLocation);
        case LOCATION_TYPE_LOCAL_FILE:
            return await api.getNetworkFileText(documentLocation);
        default:
            throw new Error(
                `Unknown document location type: ${documentLocationType}`,
            );
    }
    //
};

// (QfsAccess, SharePointAccess, FormLocation) -> Promise[DOMDocument]
export const getDocumentXmlAsync = async (api, shpAccess, formLocation) => {
    try {
        return parseXml(await getDocumentText(api, shpAccess, formLocation));
    } catch (err) {
        console.error('Error loading document XML', err);

        const messagePart = err.message || '(unknown error)';
        err.userDisplayMessage = `An error occurred trying to load the document at:\n${formLocation[FORM_LOCATION_PROP_DOCUMENT_LOCATION]}\n\n${messagePart}`;

        throw err;
    }
};
